import { createSvgComponent } from "../../icon/createSvgComponent";
import Add from "@core/__generated__/icon/figma/add.svg";
export default createSvgComponent(Add);